const formatFlight = (airport) => ({
  id: airport?.airportCode || airport?.cityCode || '',
  cityCode: airport?.cityCode || '',
})

const getFlights = (airports) => [
  {
    departureAirport: formatFlight(airports[0]),
    arrivalAirport: formatFlight(airports[1]),
  },
]

export { getFlights }
